import React, { useState } from "react";
import "./App.css";

const email = "bharalijyotirmoy@gmail.com";
const profiles = {
  about: {
    name: "Jyotirmoy Bharali",
    role: "Backend Python Developer",
    location: "Guwahati, Assam",
    experience: "3+ years",
    focus: ["REST APIs", "Production systems", "Automation"],
  },
  stack: {
    language: "Python",
    frameworks: ["Django", "FastAPI", "Flask"],
    data: ["PostgreSQL", "MongoDB"],
    workers: ["Celery", "Redis"],
    deploy: ["Docker", "AWS EC2", "Linux"],
  },
  contact: {
    email,
    github: "joe985-collab",
    location: "Guwahati, Assam",
    next_step: "Let’s build something useful.",
  },
};
const projects = [
  {
    title: "AI Video Summarizer",
    type: "APPLICATION BACKEND",
    number: "01",
    icon: "▶",
    description:
      "From video uploads to backend processing. A FastAPI application with the authentication and data workflows behind the experience.",
    tags: ["FastAPI", "PostgreSQL", "Authentication"],
    details: [
      "Registration and login flows",
      "Email OTP verification",
      "File handling and backend processing workflows",
    ],
    className: "video",
  },
  {
    title: "News Monitoring",
    type: "DATA & AUTOMATION",
    number: "02",
    icon: "≋",
    description:
      "Automated data collection built around Python, Selenium and MongoDB. Maintaining crawlers and resolving reliability issues.",
    tags: ["Python", "Selenium", "MongoDB"],
    details: [
      "Automated news collection and monitoring",
      "Crawling and automation maintenance",
      "Reliability troubleshooting",
    ],
    className: "news",
  },
  {
    title: "Attendance Portal",
    type: "INTERNAL BUSINESS TOOL",
    number: "03",
    icon: "⌘",
    description:
      "An internal Flask application brought into production on AWS EC2, with Caddy Server and hands-on deployment support.",
    tags: ["Flask", "AWS EC2", "Caddy"],
    details: [
      "Flask-based internal application",
      "AWS EC2 and Caddy deployment",
      "Production troubleshooting and support",
    ],
    className: "attendance",
  },
];
const jobs = [
  {
    company: "Mazel Group of Companies",
    role: "Web Developer",
    date: "FEB 2026 — PRESENT",
    location: "Guwahati",
    text: "Developing and maintaining live web applications and business platforms. Working across API integrations, feature delivery, debugging and production stability.",
  },
  {
    company: "Pinaca Technologies",
    role: "Software Engineer",
    date: "AUG 2022 — FEB 2025",
    location: "Guwahati",
    text: "Built and maintained Python applications, REST APIs, internal portals and data-driven tools. Worked with PostgreSQL, MongoDB, Redis/Celery workflows, Selenium automation and Linux deployment support.",
  },
  {
    company: "Business Web Solutions",
    role: "Web Development Intern",
    date: "APR 2022 — JUL 2022",
    location: "Remote",
    text: "Supported web application implementation, page development and frontend/backend integration.",
  },
];
const skills = [
  [
    "01",
    "Backend engineering",
    "Python · Django · FastAPI · Flask · REST APIs · Authentication · Third-party integrations",
  ],
  [
    "02",
    "Data & background jobs",
    "PostgreSQL · MongoDB · SQLAlchemy · SQL · Redis · Celery",
  ],
  [
    "03",
    "Automation & delivery",
    "Selenium · BeautifulSoup · Docker · AWS EC2 · Linux · Caddy · Railway · Vercel",
  ],
  [
    "04",
    "Frontend integration",
    "HTML · CSS · JavaScript · React · Vue · SvelteJS",
  ],
];

function App() {
  const [tab, setTab] = useState<keyof typeof profiles>("about");
  const [menu, setMenu] = useState(false);
  const [copied, setCopied] = useState("");
  const [requestState, setRequestState] = useState<
    "idle" | "loading" | "success"
  >("idle");
  const [responseCopied, setResponseCopied] = useState(false);

  async function runRequest() {
    if (requestState === "loading") return;
    setRequestState("loading");
    setResponseCopied(false);
    await new Promise((resolve) => window.setTimeout(resolve, 750));
    setRequestState("success");
    window.setTimeout(() => setRequestState("idle"), 2200);
  }

  async function copyResponse() {
    try {
      await navigator.clipboard.writeText(
        JSON.stringify(profiles[tab], null, 2),
      );
      setResponseCopied(true);
      window.setTimeout(() => setResponseCopied(false), 1800);
    } catch {
      setResponseCopied(false);
    }
  }
  async function copyEmail() {
    try {
      await navigator.clipboard.writeText(email);
      setCopied("Email copied");
    } catch {
      setCopied("Copy manually: " + email);
    }
  }
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <header className="header">
        <a href="#home" className="brand" aria-label="Jyotirmoy Bharali home">
          jb<span>.</span>
        </a>
        <button
          className="menu-toggle"
          aria-expanded={menu}
          aria-controls="navigation"
          onClick={() => setMenu(!menu)}
        >
          {menu ? "Close −" : "Menu +"}
        </button>
        <nav
          id="navigation"
          className={menu ? "nav open" : "nav"}
          aria-label="Main navigation"
        >
          {["Work", "Experience", "About"].map((name) => (
            <a
              key={name}
              href={"#" + name.toLowerCase()}
              onClick={() => setMenu(false)}
            >
              {name}
            </a>
          ))}
          <a
            className="nav-contact"
            href="#contact"
            onClick={() => setMenu(false)}
          >
            Let’s talk <span>↗</span>
          </a>
        </nav>
      </header>
      <main id="main" tabIndex={-1}>
        <section className="hero wrap" id="home">
          <div className="hero-copy">
            <p className="eyebrow">
              <span className="status-dot" /> PYTHON BACKEND DEVELOPER
            </p>
            <h1>
              Behind every
              <br />
              great product,
              <br />
              <span>a solid backend.</span>
            </h1>
            <p className="intro">
              I’m <strong>Jyotirmoy Bharali.</strong> I build APIs, automate
              workflows, and keep production systems moving. Based in Guwahati,
              India.
            </p>
            <div className="hero-actions">
              <a href="#work" className="button primary">
                Explore my work <span>↗</span>
              </a>
              <a
                href="/Jyotirmoy_Bharali_Resume.pdf"
                className="resume-link"
                download
              >
                Download résumé <span>↓</span>
              </a>
            </div>
            <div className="hero-facts">
              <div>
                <strong>
                  3+<span> years</span>
                </strong>
                <small>Professional experience</small>
              </div>
              <div>
                <strong>
                  Python<span> first.</span>
                </strong>
                <small>From API to production</small>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="orbit orbit-one" />
            <div className="orbit orbit-two" />
            <span className="visual-cross">+</span>
            <div className={`api-card request-${requestState}`}>
              <div className="window-bar">
                <div className="window-dots">
                  <i />
                  <i />
                  <i />
                </div>
                <span>developer.api</span>
                <span>⌘</span>
              </div>
              <div className="endpoint">
                <span>GET</span>
                <code>/v1/{tab}</code>
                <small>
                  {requestState === "loading" ? "FETCHING…" : "200 OK"}
                </small>
              </div>
              <div className="api-tabs" aria-label="Profile endpoints">
                {(["about", "stack", "contact"] as const).map((t) => (
                  <button
                    key={t}
                    aria-pressed={tab === t}
                    className={tab === t ? "selected" : ""}
                    onClick={() => setTab(t)}
                  >
                    {t}
                  </button>
                ))}
              </div>
              <pre
                aria-live="polite"
                tabIndex={0}
                aria-label="Profile response"
              >
                {requestState === "loading"
                  ? "Connecting to developer.api\n\n[■□□□□] authenticating\n[■■■□□] querying profile\n[■■■■■] response ready"
                  : JSON.stringify(profiles[tab], null, 2)}
              </pre>
              <div className="api-actions">
                <button
                  onClick={runRequest}
                  disabled={requestState === "loading"}
                >
                  <span className="play-icon">
                    {requestState === "loading" ? "···" : "▶"}
                  </span>
                  {requestState === "success"
                    ? "Request complete"
                    : requestState === "loading"
                      ? "Running request"
                      : "Run request"}
                </button>
                <button
                  onClick={copyResponse}
                  disabled={requestState === "loading"}
                >
                  {responseCopied ? "Copied ✓" : "Copy response ⧉"}
                </button>
              </div>
              <div className="api-footer">
                <span>
                  <i /> PROFILE RESPONSE
                </span>
                <span>application/json</span>
              </div>
            </div>
            <div className="visual-caption">
              <span>BUILD. DEBUG. SHIP.</span>
              <span>↳ REPEAT.</span>
            </div>
          </div>
        </section>
        <div className="stack-strip">
          <div className="wrap">
            <span className="strip-label">THE EVERYDAY TOOLKIT</span>
            {[
              "Python",
              "Django",
              "FastAPI",
              "PostgreSQL",
              "Redis",
              "Docker",
            ].map((s) => (
              <span key={s}>{s}</span>
            ))}
          </div>
        </div>
        <section id="work" className="section wrap">
          <div className="section-heading">
            <div>
              <p className="eyebrow">01 / SELECTED WORK</p>
              <h2>Built for real use.</h2>
            </div>
            <p>
              Authentication, automation, deployment.
              <br />
              The work behind the interface.
            </p>
          </div>
          <div className="project-grid">
            {projects.map((p) => (
              <article className="project-card" key={p.title}>
                <div
                  className={"project-art " + p.className}
                  aria-hidden="true"
                >
                  <span className="art-number">/{p.number}</span>
                  <div className="art-icon">{p.icon}</div>
                  <div className="art-lines">
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                  </div>
                  <span className="art-caption">{p.type}</span>
                </div>
                <div className="project-body">
                  <p className="eyebrow">{p.type}</p>
                  <h3>{p.title}</h3>
                  <p>{p.description}</p>
                  <div className="tags">
                    {p.tags.map((t) => (
                      <span key={t}>{t}</span>
                    ))}
                  </div>
                  <details>
                    <summary>
                      Explore the work <span>+</span>
                    </summary>
                    <ul>
                      {p.details.map((d) => (
                        <li key={d}>{d}</li>
                      ))}
                    </ul>
                  </details>
                </div>
              </article>
            ))}
          </div>
          <p className="work-note">
            Selected work from my résumé. Source code and live demos are not
            publicly linked here.
          </p>
        </section>
        <section id="experience" className="section wrap experience">
          <div>
            <p className="eyebrow">02 / THE JOURNEY</p>
            <h2>
              Experience.
              <br />
              <span className="muted">In production.</span>
            </h2>
            <p className="section-intro">
              Building new features is only part of the job. Keeping real
              systems reliable is the rest.
            </p>
          </div>
          <div className="timeline">
            {jobs.map((j, i) => (
              <article className="job" key={j.company}>
                <div className={"timeline-dot " + (i === 0 ? "current" : "")} />
                <p className="job-date">
                  {j.date}
                  {i === 0 && <span>NOW</span>}
                </p>
                <h3>{j.role}</h3>
                <p className="company">
                  {j.company} <span> / {j.location}</span>
                </p>
                <p>{j.text}</p>
              </article>
            ))}
          </div>
        </section>
        <section id="about" className="section wrap">
          <div className="section-heading">
            <div>
              <p className="eyebrow">03 / THE PERSON & THE TOOLKIT</p>
              <h2>
                Curious by nature.
                <br />
                Backend by choice.
              </h2>
            </div>
            <p>
              My background combines software development
              <br />
              with an M.Tech in information security.
            </p>
          </div>
          <div className="about-grid">
            <div className="about-copy">
              <figure className="profile-photo">
                <img
                  src="/profile.jpg"
                  alt="Jyotirmoy Bharali"
                  width="720"
                  height="900"
                  loading="lazy"
                />
                <figcaption>
                  <span>Jyotirmoy Bharali</span>
                  <span>Guwahati, Assam</span>
                </figcaption>
              </figure>
              <p>
                I’m a backend-focused Python developer with 3+ years of
                professional experience across web applications, APIs, and
                production business systems.
              </p>
              <p>
                I enjoy the practical side of engineering: connecting services,
                processing data, untangling live issues, and turning business
                requirements into working software.
              </p>
              <div className="education">
                <p className="eyebrow">EDUCATION</p>
                <h4>M.Tech · Cyber Forensics & Information Security</h4>
                <p>GITAM University · 2020–2022</p>
                <h4>B.Tech · Electrical Engineering</h4>
                <p>Assam Science and Technology University · 2014–2018</p>
              </div>
            </div>
            <div className="skills">
              {skills.map(([n, title, items]) => (
                <div className="skill-row" key={n}>
                  <span>{n}</span>
                  <div>
                    <h3>{title}</h3>
                    <p>{items}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section id="contact" className="contact-section">
          <div className="wrap">
            <p className="eyebrow">04 / WHAT’S NEXT?</p>
            <h2>
              Good things start
              <br />
              with a <span>conversation.</span>
            </h2>
            <p>Have a backend challenge or a role in mind? Let’s talk.</p>
            <div className="contact-actions">
              <a className="button primary" href={"mailto:" + email}>
                Say hello <span>↗</span>
              </a>
              <button className="copy-button" onClick={copyEmail}>
                Copy email <span>⧉</span>
              </button>
            </div>
            <p className="copy-status" role="status">
              {copied}
            </p>
            <a className="email-link" href={"mailto:" + email}>
              {email}
            </a>
          </div>
        </section>
      </main>
      <footer className="wrap footer">
        <a href="#home" className="brand" aria-label="Back to top">
          jb<span>.</span>
        </a>
        <p>© {new Date().getFullYear()} Jyotirmoy Bharali</p>
        <div>
          <a
            href="https://github.com/joe985-collab"
            target="_blank"
            rel="noreferrer"
          >
            GitHub ↗
          </a>
          <a
            href="https://www.linkedin.com/in/jyotirmoy-bharali-821343224/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn ↗
          </a>
          <a href="#home">Back to top ↑</a>
        </div>
      </footer>
    </>
  );
}
export default App;
